import React from 'react';

import { useLocalizationContext } from '@order/Localization';

import { AccountMenuPrimaryItem } from '../AccountMenuPrimaryItem';

export const AccountMenuSignOutItem = (props: AccountMenuSignOutProps) => {
  const { isSigningOut, onSignOut } = props;

  const { t } = useLocalizationContext();

  return (
    <AccountMenuPrimaryItem
      testID="account.sidebar-tab.sign-out"
      label={t('account.sidebar.sign-out')}
      iconName="IconLogout"
      disabled={isSigningOut}
      onPress={onSignOut}
    />
  );
};

type AccountMenuSignOutProps = Readonly<{
  isSigningOut: boolean;
  onSignOut: () => void;
}>;
